module.exports = __webpack_public_path__ + "img/file.2431977e.svg";